import { Suspense } from 'react';
import { SellerReturnsClient } from './seller-returns-client';

export default function Page() {
  return (
    <Suspense fallback={null}>
      <SellerReturnsClient />
    </Suspense>
  );
}
